import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "./JobCategory.css";

const url = process.env.REACT_APP_BACKEND_URL;

const EditJobCategory = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    category_name: "",
    description: ""
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${url}/api/jobcategory/${id}`);
        setData({
          category_name: res.data.data.category_name,
          description: res.data.data.description || ""
        });
      } catch (error) {
        toast.error("Failed to load category");
        navigate("/ViewJobcategory");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id, navigate]);

  const submit = async (e) => {
    e.preventDefault();

    if (!data.category_name) {
      toast.error("Category name is required");
      return;
    }

    try {
      await axios.put(`${url}/api/jobcategory/${id}`, data);
      toast.success("Category updated successfully");
      navigate("/ViewJobcategory");
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update");
    }
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="form-wrapper">
      <div className="country-form-container">
        <h2 className="form-title">Edit Job Category</h2>
        <form className="country-form" onSubmit={submit}>
          <div className="form-field filled">
            <input
              type="text"
              name="category_name"
              value={data.category_name}
              onChange={(e) =>
                setData({ ...data, category_name: e.target.value })
              }
              required
            />
            <label>Category Name</label>
          </div>
          <div className="form-field filled">
            <textarea
              rows="4"
              value={data.description}
              onChange={(e) =>
                setData({ ...data, description: e.target.value })
              }
            />
            <label>Description</label>
          </div>
          <button className="submit-btn">Update Category</button>
        </form>
      </div>
    </div>
  );
};

export default EditJobCategory;